import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

export default function EmptyPage({ title, subtitle, icon, fit, ...rest }) {
  const { t } = useTranslation();

  return (
    <S.EmptyPageContainer {...rest}>
      <S.Background fit={fit} />
      <S.Content>
        <S.Icon name={icon} height={58} width={44} color="gray" />
        <S.Title fit={fit}>{title || t('emptyTitle')}</S.Title>
        <S.Subtitle fit={fit}>{subtitle || t('emptySubtitle')}</S.Subtitle>
      </S.Content>
    </S.EmptyPageContainer>
  );
}

EmptyPage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  fit: PropTypes.bool,
};

EmptyPage.defaultProps = {
  title: null,
  subtitle: null,
  icon: 'file',
  fit: false,
};
